import { Button, Typography, emptyFragment } from '@execonline-inc/execonline-ui';
import { Maybe } from 'maybeasy';
import { observer } from 'mobx-react';
import { T } from '../../../../../../../Translations';
import { useExperienceFilters } from '../../../Filters/FiltersContext';
import ClearSearchButton from '../ExperienceActions/ClearSearchButton';

interface Props {
  searchValue: Maybe<string>;
}

function NoExperiences({ searchValue }: Props) {
  const { appliedFilterCount, clearFilters } = useExperienceFilters();

  return (
    <div
      className="mt-8 flex flex-col items-center gap-y-4"
      data-testid="no-experiences-found"
      data-intercom-target="discovery-portal-no-results"
    >
      <Typography variant="subtitleMedium" as="p" tabIndex={0}>
        {searchValue
          .map((term) => <T key="search" kind={'No courses match "{{term}}"'} term={term} />)
          .orElse(() =>
            appliedFilterCount.map(() => (
              <T key="filters" kind="No courses match the selected filters" />
            )),
          )
          .getOrElse(() => (
            <T kind="No courses to show" />
          ))}
      </Typography>
      <div className="flex flex-wrap justify-center gap-2">
        {searchValue.map(() => <ClearSearchButton key="clear-search" />).getOrElse(emptyFragment)}
        {appliedFilterCount
          .map(() => (
            <Button
              key="clear-filters"
              size="sm"
              variant="outlined"
              data-intercom-target="discovery-portal-clear-filters-button"
              onClick={clearFilters}
            >
              <T kind="Clear filters" />
            </Button>
          ))
          .getOrElse(emptyFragment)}
      </div>
    </div>
  );
}

export default observer(NoExperiences);
